import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'allNumeric',
    standalone: false,
})
export class AllNumericPipe implements PipeTransform {
    constructor() {}

    transform(input: any[], key: unknown): boolean {
        if (input.length == 0) {
            return false;
        }
        let hasNumber = false;
        for (let val of input) {
            const value = val[key as keyof typeof val];
            if (typeof value == 'string' && value.length && isNaN(Number(value))) {
                return false;
            }
            if (typeof value == 'number' || (typeof value == 'string' && value.length > 0 && !isNaN(Number(value)))) {
                hasNumber = true;
            }
        }
        return hasNumber;
    }
}
